(function (win, $) {
    var agileIframe = $(".agile-iframe-holder, .account-info-holder");
    var headerAuth = $(".header__auth");
    var headerAvatar = $(".header__auth-icon");
    var accountName = $(".account-holder .profile-name");
    var accountAvatar = $(".account-holder .profile-avatar");
    var accountPhoto = $(".account-holder .profile-avatar-photo");
    var accountId = $(".profile-name-holder .profile-id");
    var headerName = $(".header__auth-text");
    var logoutLink = $(".logout-link a");
    var headerBasket = $(".agile_cart");
    var headerBasketHolder = $(".header__cart");
    var listsFormWrap = $('.newsletter-form-wrap');
    var signInLink = vars["signin_url"];
    var accountLink = vars["account_url"];
    var login_state = Cookies.get('logged-in');

    var pageGroupingTitle = vars["mParticle_page_data"]["page_grouping_title"];
    var pageTitle = vars["mParticle_page_data"]["title"];

    var url_without_params = window.location.href.split('?')[0];
    var url_full = window.location.toString();

    var account_id = '';
    var account_email = '';
    var service = 'docnyc';
    var platform = 'web';
    var $FirstName = '';
    var $LastName = '';
    var $Mobile = '';


    function bindEvent(element, eventName, eventHandler) {
        if (element.addEventListener) {
            element.addEventListener(eventName, eventHandler, false);
        } else if (element.attachEvent) {
            element.attachEvent('on' + eventName, eventHandler);
        }
    }

    // Listen to message from child window
    bindEvent(window, 'message', function (e) {
        if (e.origin != 'https://js.driftt.com') {
            if (e.data.length) {
                message = $.parseJSON(e.data);
                console.log(message);
                var iframeHeight = message['bodyHeight'];
                agileIframe.find("iframe").css({"min-height": iframeHeight + "px"});
                setTimeout(function () {
                    $("html, body").animate({scrollTop: 0}, 250);
                }, 100);
                if ("userLoggedIn" in message) {
                    if (message["userLoggedIn"]) {
                        if (window.location == signInLink) {
                            agileIframe.css({opacity: "0"});
                        }
                        $(".agile-iframe-holder.sign-in").css({
                            transition: "opacity .3s",
                            opacity: 0
                        });
                        Cookies.set('logged-in', 'true');
                        Cookies.set('user-name', message["userName"]);
                        Cookies.set('user-photo', message["userImage"]);
                        Cookies.set('user-first-name', message["userFirst"]);
                        Cookies.set('user-last-name', message["userLast"]);
                        Cookies.set('user-email', message["userEmail"]);
                        Cookies.set('basket-count', message["basketCount"]);
                        Cookies.set('user-id', message["userNumber"]);

                        account_id = message["userNumber"];
                        account_email = message["userEmail"];
                        $FirstName = message["userFirst"];
                        $LastName = message["userLast"];
                        if (logoutLink.length) {
                            logoutLink.show();
                        }
                        initCookie();

                    } else {
                        headerAvatar.removeClass("active").find(".header-avatar").remove();
                        headerName.text("Sign In");
                        if (logoutLink.length) {
                            logoutLink.hide();
                        }
                        if (accountAvatar.length) {
                            accountAvatar.addClass("hide");
                        }
                        headerBasketHolder.hide();
                        Cookies.remove('logged-in');
                        Cookies.remove('user-name');
                        Cookies.remove('user-photo');
                        Cookies.remove('user-first-name');
                        Cookies.remove('user-last-name');
                        Cookies.remove('user-email');
                        Cookies.remove('basket-count');
                        Cookies.remove('user-id');
                        Cookies.remove('already-logged-in');

                        alreadyLogIn = 0;
                        account_id = '';
                        account_email = '';
                        $FirstName = '';
                        $LastName = '';
                        $Mobile = '';
                    }
                }

                if ("action" in message && message["userLoggedIn"] && !Cookies.get('already-logged-in')) {
                    var identityRequest = {
                        userIdentities: {
                            email: account_email,
                            customerid: account_id
                        }
                    };
                    var identityCallback = function (result) {
                        if (result.getUser()) {
                            //Set User Attributes
                            var currentUser = mParticle.Identity.getCurrentUser();
                            currentUser.setUserAttribute("account_id", account_id);
                            currentUser.setUserAttribute("account_email", account_email);
                            currentUser.setUserAttribute("service", service);
                            currentUser.setUserAttribute("platform", platform);
                            currentUser.setUserAttribute("$FirstName", $FirstName);
                            currentUser.setUserAttribute("$LastName", $LastName);
                            currentUser.setUserAttribute("$Mobile", $Mobile);
                            //Some else depend on event

                            //Custom Events
                            mParticle.logEvent(
                                'account_sign_in',
                                mParticle.EventType.Other,
                                {
                                    'account_id': account_id,
                                    'service': 'docnyc',
                                    'platform': 'web',
                                    'full_url': url_full,
                                    'url': url_without_params,
                                    'account_email': account_email
                                }
                            );

                            Cookies.set('already-logged-in', 'true');
                            window.location.href = accountLink;
                        }
                    };
                    mParticle.Identity.login(identityRequest, identityCallback);
                }

                if ("action" in message && message["action"] === "account_create") {
                    //User identify
                    var identityRequest = {
                        userIdentities: {
                            email: message["data"]["userEmail"],
                            customerid: message["data"]["userNumber"]
                        }
                    };
                    var identityCallback = function (result) {
                        if (result.getUser()) {
                            //Set User Attributes
                            var currentUser = mParticle.Identity.getCurrentUser();
                            currentUser.setUserAttribute("account_id", account_id);
                            currentUser.setUserAttribute("account_email", account_email);
                            currentUser.setUserAttribute("service", service);
                            currentUser.setUserAttribute("platform", platform);
                            currentUser.setUserAttribute("$FirstName", $FirstName);
                            currentUser.setUserAttribute("$LastName", $LastName);
                            currentUser.setUserAttribute("$Mobile", $Mobile);
                            //Some else depend on event

                            //Custom Events
                            mParticle.logEvent(
                                'account_sign_up',
                                mParticle.EventType.Other,
                                {
                                    'account_id': account_id,
                                    'service': 'docnyc',
                                    'platform': 'web',
                                    'full_url': url_full,
                                    'url': url_without_params,
                                    'account_email': message["data"]["userEmail"]
                                }
                            );
                        }
                    };
                    mParticle.Identity.identify(identityRequest, identityCallback);
                }
                if ("action" in message && message["action"] === "account_upate") {
                    var identityRequest = {
                        userIdentities: {
                            email: message["data"]["userEmail"],
                            customerid: account_id
                        }
                    };
                    var identityCallback = function (result) {
                        if (result.getUser()) {
                            //Set User Attributes
                            var currentUser = mParticle.Identity.getCurrentUser();
                            currentUser.setUserAttribute("account_id", account_id);
                            currentUser.setUserAttribute("account_email", message["data"]["userEmail"]);
                            currentUser.setUserAttribute("service", service);
                            currentUser.setUserAttribute("platform", platform);
                            currentUser.setUserAttribute("$FirstName", message["data"]["userFirst"]);
                            currentUser.setUserAttribute("$LastName", message["data"]["userLast"]);
                            currentUser.setUserAttribute("$Mobile", message["data"]["userPhone"]);
                            //Custom Events
                            mParticle.logEvent(
                                'account_update',
                                mParticle.EventType.Other,
                                {
                                    'account_id': account_id,
                                    'service': service,
                                    'platform': platform,
                                    'full_url': url_full,
                                    'url': url_without_params,
                                    'affliations': "" + message["data"]["meta"][0]["name"] + ": " + message["data"]["meta"][0]["ans"] + "",
                                    'update_field': "userEmail: " + message["data"]["userEmail"] + ", " +
                                        "userFirst: " + message["data"]["userFirst"] + ", " +
                                        "userLast: " + message["data"]["userLast"] + ", " +
                                        "userPhone: " + message["data"]["userPhone"] + ", " +
                                        "" + message["data"]["meta"][0]["name"] + ": " + message["data"]["meta"][0]["ans"] + ""
                                }
                            );
                        }
                    };
                    mParticle.Identity.identify(identityRequest, identityCallback);
                }
                if ("action" in message && message["action"] === "forgot_password") {
                    var identityRequest = {
                        userIdentities: {
                            email: message["data"]["userEmail"],
                            customerid: account_id
                        }
                    };
                    var identityCallback = function (result) {
                        if (result.getUser()) {
                            //Set User Attributes
                            //Custom Events
                            mParticle.logEvent(
                                'account_forgot_password',
                                mParticle.EventType.Other,
                                {
                                    'account_id': account_id,
                                    'service': service,
                                    'platform': platform,
                                    'full_url': url_full,
                                    'url': url_without_params,
                                    'account_email': message["data"]["userEmail"]
                                }
                            );
                        }
                    };
                    mParticle.Identity.identify(identityRequest, identityCallback);
                }
                if ("action" in message && message["action"] === "add_to_cart") {
                    var quantity = 0;
                    var price = 0;
                    message["data"].forEach(function (item) {
                        price += (item.price * item.quantity);
                        quantity += item.quantity;
                    });
                    var identityRequest = {
                        userIdentities: {
                            email: account_email,
                            customerid: account_id
                        }
                    };
                    var identityCallback = function (result) {
                        if (result.getUser()) {
                            //Set User Attributes
                            //Some else depend on event

                            //Custom Events
                            mParticle.logEvent(
                                'add_to_cart',
                                mParticle.EventType.Other,
                                {
                                    'account_id': account_id,
                                    'service': service,
                                    'platform': platform,
                                    'full_url': url_full,
                                    'url': url_without_params,

                                    'product_id': message["data"][0].id,
                                    'product_name': message["data"][0].name,
                                    'product_price': price,
                                    'product_quantity': quantity
                                }
                            );
                        }
                    };
                    mParticle.Identity.identify(identityRequest, identityCallback);
                }
                if ("action" in message && message["action"] === "remove_from_cart") {
                    var quantity = 0;
                    message["data"].forEach(function (item) {
                        quantity += item.quantity;
                    });
                    var identityRequest = {
                        userIdentities: {
                            email: account_email,
                            customerid: account_id
                        }
                    };
                    var identityCallback = function (result) {
                        if (result.getUser()) {
                            //Set User Attributes
                            //Some else depend on event

                            //Custom Events
                            mParticle.logEvent(
                                'update_to_cart',
                                mParticle.EventType.Other,
                                {
                                    'account_id': account_id,
                                    'service': service,
                                    'platform': platform,
                                    'full_url': url_full,
                                    'url': url_without_params,

                                    'event_action': 'Item Removed',
                                    'product_id': message["data"][0].id,
                                    'product_name': message["data"][0].name,
                                    'product_quantity': quantity
                                }
                            );
                        }
                    };
                    mParticle.Identity.identify(identityRequest, identityCallback);
                }
                if ("action" in message && message["action"] === "promo_applied") {

                    var amount = message["data"][0]["quantity"] * message["data"][0]["price"];
                    var identityRequest = {
                        userIdentities: {
                            email: account_email,
                            customerid: account_id
                        }
                    };
                    var identityCallback = function (result) {
                        if (result.getUser()) {
                            //Set User Attributes
                            //Some else depend on event

                            //Custom Events
                            mParticle.logEvent(
                                'promo_apply',
                                mParticle.EventType.Other,
                                {
                                    'account_id': account_id,
                                    'service': service,
                                    'platform': platform,
                                    'full_url': url_full,
                                    'url': url_without_params,

                                    'promo_code': message["data"][0]["code"],
                                    'promo_discount_amount': amount
                                }
                            );
                        }
                    };
                    mParticle.Identity.identify(identityRequest, identityCallback);
                }
                if ("action" in message && message["action"] === "checkout") {
                    var productsList = '';
                    message["data"]["products"].forEach(function (product) {
                        productsList += "" + product.id + ": " + product.quantity + ",";
                    });
                    productsList = productsList.slice(0, productsList.length - 1);
                    var identityRequest = {
                        userIdentities: {
                            email: account_email,
                            customerid: account_id
                        }
                    };
                    var identityCallback = function (result) {
                        if (result.getUser()) {
                            //Set User Attributes
                            //Some else depend on event

                            //Custom Events
                            mParticle.logEvent(
                                'checkout',
                                mParticle.EventType.Other,
                                {
                                    'account_id': account_id,
                                    'service': service,
                                    'platform': platform,
                                    'full_url': url_full,
                                    'url': url_without_params,

                                    'product_id_list': productsList
                                }
                            );
                        }
                    };
                    mParticle.Identity.identify(identityRequest, identityCallback);
                }
                if ("action" in message && message["action"] === "purchase") {
                    var total = message["data"]["actionField"]["revenue"];
                    var tax = message["data"]["actionField"]["tax"];
                    var shipping = message["data"]["actionField"]["shipping"];
                    var subtotal = total - tax - shipping;
                    var productsList = '';
                    message["data"]["products"].forEach(function (product) {
                        productsList += "" + product.id + ": " + product.quantity + ", ";
                    });
                    productsList = productsList.slice(0, productsList.length - 1);


                    var identityRequest = {
                        userIdentities: {
                            email: account_email,
                            customerid: account_id
                        }
                    };
                    var identityCallback = function (result) {
                        if (result.getUser()) {
                            //Set User Attributes
                            //Some else depend on event

                            //Custom Events
                            mParticle.logEvent(
                                'purchase',
                                mParticle.EventType.Other,
                                {
                                    'account_id': account_id,
                                    'service': service,
                                    'platform': platform,
                                    'full_url': url_full,
                                    'url': url_without_params,

                                    'product_id_list': productsList,
                                    'receipt_id': message["data"]["actionField"]["id"],
                                    'subtotal': subtotal,
                                    'total': total
                                }
                            );
                        }
                    };
                    mParticle.Identity.identify(identityRequest, identityCallback);
                }
            }
        }
    });

    if (login_state == "true") {
        headerAuth.find("a").attr("href", accountLink);

        initCookie();

        if (window.location == signInLink && Cookies.get('already-logged-in')) {
            window.location.href = accountLink;
        }
        if (logoutLink.length) {
            logoutLink.show();
        }
        if (accountAvatar.length) {
            accountAvatar.removeClass("hide");
        }
    } else {
        headerAuth.find("a").attr("href", signInLink);
        if ($(".dashboard-page").length && window.location != signInLink) {
            window.location.href = signInLink;
        }
        if (logoutLink.length) {
            logoutLink.hide();
        }
        if (accountAvatar.length) {
            accountAvatar.addClass("hide");
        }
    }

    function initCookie() {
        if (Cookies.get('user-photo')) {
            headerAvatar.addClass("active");
            $('<i class="header-avatar"></i>').appendTo(headerAvatar);
            $(".header-avatar").css({
                "background-image": "url(" + Cookies.get('user-photo') + ")"
            });
            if (accountPhoto.length) {
                accountPhoto.css({
                    "background-image": "url(" + Cookies.get('user-photo') + ")"
                });
            }
        } else {
            headerAvatar.removeClass("active");
            if (accountPhoto.length) {
                accountPhoto.removeAttr("style").find("span").text(Cookies.get('user-first-name').charAt(0) + Cookies.get('user-last-name').charAt(0));
            }
        }
        headerName.text(Cookies.get('user-first-name') + ' ' + Cookies.get('user-last-name').charAt(0) + '.');
        if (accountId.length) {
            accountId.text("#" + Cookies.get('user-id'));
        }

        if (accountName.length) {
            accountName.text(Cookies.get('user-name'));
        }
        if (Cookies.get('basket-count') > 0 && !$(".header-basket-count").length) {
            $('<span class="header-basket-count"></span>').appendTo(headerBasket);
        }
        if (login_state == "true") {
            headerBasketHolder.show();
        } else {
            headerBasketHolder.hide();
        }
        if ($(".header-basket-count").length) {
            if (Cookies.get('basket-count') > 0) {
                $(".header-basket-count").text(Cookies.get('basket-count'));
            } else {
                $(".header-basket-count").remove();
            }
        }
    }

    logoutLink.click(function (e) {
        e.preventDefault();
        //User identify
        // var identityRequest = {
        //     userIdentities: {
        //         email: account_email,
        //         customerid: account_id
        //     }
        // };
        var identityCallback = function (result) {
            if (result.getUser()) {
                //Set User Attributes
                var currentUser = mParticle.Identity.getCurrentUser();
                currentUser.setUserAttribute("account_id", account_id);
                currentUser.setUserAttribute("account_email", account_email);
                currentUser.setUserAttribute("service", service);
                currentUser.setUserAttribute("platform", platform);
                currentUser.setUserAttribute("$FirstName", $FirstName);
                currentUser.setUserAttribute("$LastName", $LastName);
                currentUser.setUserAttribute("$Mobile", $Mobile);

                // mParticle
                //Custom Events
                mParticle.logEvent(
                    'account_sign_out',
                    mParticle.EventType.Other,
                    {
                        'account_id': account_id,
                        'service': 'docnyc',
                        'platform': 'web',
                        'full_url': url_full,
                        'url': url_without_params,

                        'category': url_full,
                        'action': 'active',

                        'account_email': account_email
                    }
                );
            }
        };
        mParticle.Identity.logout({}, identityCallback);
        // mParticle.Identity.logout(identityRequest, identityCallback);

        var src = $(this).attr('href');
        if (agileIframe.find('iframe').length) {
            agileIframe.find('iframe').attr('src', src);
        } else {
            agileIframe.html('<iframe src="' + src + '"></iframe>');
        }
        if ($(".header-basket-count").length) {
            $(".header-basket-count").remove();
        }
        setTimeout(function () {
            Cookies.remove('logged-in');
            Cookies.remove('user-name');
            Cookies.remove('user-photo');
            Cookies.remove('user-first-name');
            Cookies.remove('user-last-name');
            Cookies.remove('user-email');
            Cookies.remove('basket-count');
            Cookies.remove('user-id');
            Cookies.remove('already-logged-in');

            alreadyLogIn = 0;
            account_id = '';
            account_email = '';
            $FirstName = '';
            $LastName = '';
            $Mobile = '';
            headerBasketHolder.hide();
            window.location.href = signInLink
        }, 500);
    });

    $(window).on("load", function () {
        if (window.agile.AccountEmail !== undefined && login_state != "true") {
            Cookies.set('logged-in', 'true');
            Cookies.set('user-name', window.agile.AccountName);
            Cookies.set('user-photo', window.agile.AccountImage);
            Cookies.set('user-first-name', window.agile.AccountFirst);
            Cookies.set('user-last-name', window.agile.AccountLast);
            Cookies.set('user-email', window.agile.AccountEmail);
            Cookies.set('basket-count', window.agile.CartCount);
            Cookies.set('user-id', window.agile.AccountNumber);
            headerAuth.find("a").attr("href", accountLink);
            headerName.text(window.agile.AccountFirst + ' ' + window.agile.AccountLast.charAt(0) + '.');
            if (window.agile.AccountImage) {
                headerAvatar.addClass("active");
                $('<i class="header-avatar"></i>').appendTo(headerAvatar);
                $(".header-avatar").css({
                    "background-image": "url(" + window.agile.AccountImage + ")"
                });
            }
            headerBasketHolder.show();
            if (window.agile.CartCount > 0 && !$(".header-basket-count").length) {
                $('<span class="header-basket-count"></span>').appendTo(headerBasket);
                $(".header-basket-count").text(window.agile.CartCount);
            }
        }
        if (window.agile.AccountEmail === undefined && login_state === "true") {
            headerAuth.find("a").attr("href", signInLink);
            Cookies.remove('logged-in');
            Cookies.remove('user-name');
            Cookies.remove('user-photo');
            Cookies.remove('user-first-name');
            Cookies.remove('user-last-name');
            Cookies.remove('user-email');
            Cookies.remove('basket-count');
            Cookies.remove('user-id');

            headerName.text("Sign In");
            headerBasketHolder.hide();
            if (accountAvatar.length) {
                accountAvatar.addClass("hide");
            }
            if ($(".dashboard-page").length && window.location != signInLink) {
                window.location.href = signInLink;
            }
        }
    });

    //Get mailing lists form
    if (listsFormWrap.length) {
        if (Cookies.get('user-email')) {
            var params = {
                action: 'render_newsletter_form',
                email: Cookies.get('user-email'),
                _ajax_nonce: vars.render_newsletter_form_token
            };
            $.post(vars.ajax_url, params, function (data) {
                listsFormWrap.html(data.msg);
                if ($('.newsletter-settings-email').length) {
                    $('.newsletter-settings-email').text(Cookies.get('user-email'));
                }
            });
        }
    }

    //Change status for mailing lists
    $(document).on('submit', "#listsForm", function (e) {
        e.preventDefault();
        var form = $(this),
            submit = form.find("input.button"),
            formData = form.serialize(),
            resOut = form.find('.response');
        $.each(
            form.find('input.mailing-list')
                .filter(function (idx) {
                    return $(this).prop('checked') === false
                }),
            function (idx, el) {
                var emptyVal = $(el).hasClass('interest') ? "false" : '';
                formData += '&' + $(el).attr('name') + '=' + emptyVal;
            }
        );
        var params = {
            action: 'update_subscription_status',
            data: formData,
            _ajax_nonce: vars.update_subscribe_status_token
        };
        submit.attr("disabled", "disabled").addClass('disabled');
        $.post(vars.ajax_url, params, function (data) {
            submit.removeAttr("disabled").removeClass('disabled');
            if (data.status == 'unsubscribed') {

                var identityRequest = {
                    userIdentities: {
                        email: account_email,
                        customerid: account_id
                    }
                };
                var identityCallback = function (result) {
                    if (result.getUser()) {
                        //Set User Attributes
                        var currentUser = mParticle.Identity.getCurrentUser();
                        currentUser.setUserAttribute("doc-nyc-nl", 0);

                        //Some else depend on event

                        //Custom Events
                        mParticle.logEvent(
                            'newsletter_unsubscribe',
                            mParticle.EventType.Other,
                            {
                                'account_id': account_id,
                                'service': 'docnyc',
                                'platform': 'web',
                                'full_url': url_full,
                                'url': url_without_params,

                                'newsletter_email': account_email,
                                'newsletter_id': vars["list_id"]
                            }
                        );
                    }
                };
                mParticle.Identity.identify(identityRequest, identityCallback);

                form.after(data.msg);
                form.remove();
                $("html, body").animate({scrollTop: 0}, 1000);
            } else {
                resOut.text(data.msg).show().fadeOut(3500);
            }
        });
    });

    //Uncheck all mailing lists
    $(document).on('change', 'input#unsubscribe', function () {
        if ($(this).is(':checked')) {
            $(document).find('input.mailing-list').prop('checked', false);
        }
    });

    //Uncheck unsubscribe checkbox if at least one mailing list is checked
    $(document).on('change', 'input.mailing-list', function () {
        if ($('input.mailing-list:checked').length > 0) {
            $(document).find('input#unsubscribe').prop('checked', false);
        }
    });

    // mParticle
    if (pageGroupingTitle && pageTitle) {
        mParticle.logPageView(
            pageGroupingTitle,
            {
                "url": url_without_params,
                "full_url": url_full,
                "service": service,
                "platform": platform,
                "account_id": account_id
            },
            {
                "Google.Page": url_without_params,
                "Google.Title": pageTitle
            }
        );
    }
})(window, jQuery);


// WEBPACK FOOTER //
// ./assets/js/global.js